export const ORIENTATIONS = {
  'north': 'Norte',
  'south': 'Sur',
  'east': 'Este',
  'west': 'Oeste',
  'northeast': 'Noreste',
  'northwest': 'Noroeste',
  'southeast': 'Sureste',
  'southwest': 'Suroeste',
} as const

export type Orientation = keyof typeof ORIENTATIONS

export const getOrientationDisplay = (orientation: string): string => {
  if (!orientation) return ''
  return ORIENTATIONS[orientation.toLowerCase()] || orientation
}
